import { FC, ReactNode } from 'react';
import { InfoIconFilled } from 'shared/icons';
import { IconType } from 'shared/icons/SvgIcon';
import { mergeClasses } from 'shared/utils/mergeClasses';

export type Variant = 'primary' | 'warning';

const getVariantClassNames = (variant: Variant) => {
  switch (variant) {
    case 'primary':
      return 'bg-primary/5 [&>svg]:text-primary';
    case 'warning':
      return 'bg-orange/5 [&>svg]:text-orange';
    default:
      return '';
  }
};
interface InfoBoxProps {
  message: string | ReactNode;
  variant?: Variant;
  className?: string;
  customIconAndornment?: IconType;
}

export const InfoBox: FC<InfoBoxProps> = ({
  message,
  className = '',
  variant = 'primary',
  customIconAndornment,
}) => {
  const Icon = customIconAndornment ?? InfoIconFilled;

  return (
    <div
      className={mergeClasses(
        'flex w-full gap-1.5 rounded-lg p-2',
        getVariantClassNames(variant),
        className,
      )}
    >
      {customIconAndornment ? (
        <Icon className="mt-px h-5 w-5 min-w-5" />
      ) : (
        <Icon className="mt-px h-5 w-5 min-w-5" />
      )}
      <p>{message}</p>
    </div>
  );
};
